import React, { useState } from 'react'
import LoginFrame from '../shared/LoginFrame'
import {
  useAppSelector,
  useAppDispatch,
  selectSignupData,
} from '../../store/store'
import { updateSignupField } from '../../store'
import { useAuthNavigation } from '../../hooks/useAuthActions'
import { preventDefaultAndValidate } from '../../helpers'
import {
  InjectedFrameProps,
  withFrameProps,
} from '../../context/withFrameProps'

type PureSignupEmailPromptProps = {
  initialEmail: string
  onContinue: (email: string) => void
} & InjectedFrameProps

export const PureSignupEmailPrompt = ({
  initialEmail,
  onContinue,
  ...props
}: PureSignupEmailPromptProps) => {
  const [email, setEmail] = useState(initialEmail || '')

  const handleContinue = (e: React.FormEvent) => {
    onContinue(email)
  }

  return (
    <LoginFrame
      title={'Create your account'}
      {...props}
      recaptchaSiteKey={null}
    >
      <div>
        <label
          htmlFor="email"
          className="block mb-2 text-sm font-medium text-gray-900"
        >
          Your email
        </label>
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoFocus
          tabIndex={1}
          type="email"
          name="email"
          id="email"
          autoComplete="email"
          className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
          placeholder="name@company.com"
          required
        />
      </div>
      <button
        onClick={preventDefaultAndValidate(handleContinue)}
        type="submit"
        tabIndex={2}
        className="w-full text-white bg-slate-600 hover:bg-slate-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
      >
        Next
      </button>
    </LoginFrame>
  )
}

const BoundSignupEmailPrompt = withFrameProps(PureSignupEmailPrompt, {
  hasPreviousStep: true,
})

export const SignupEmailPrompt = () => {
  const dispatch = useAppDispatch()
  const signupData = useAppSelector(selectSignupData)
  const { nextStep } = useAuthNavigation()

  const onContinue = (email: string) => {
    dispatch(updateSignupField({ field: 'email', value: email }))
    nextStep()
  }

  return (
    <BoundSignupEmailPrompt
      initialEmail={signupData?.email || ''}
      {...{ onContinue }}
    />
  )
}

export default SignupEmailPrompt
